<template>
    <span class="PlatformIcon" :class="iconClass"></span>
</template>

<style>
.PlatformIcon.fa-wordpress {
    color: #26749b;
}
.PlatformIcon.fa-instagram {
    color: #9f39a4;
}
.PlatformIcon.fa-youtube-play {
    color: #cc2327;
}
.PlatformIcon.icon-betterhype:after {
    content: '✌️';
    /*color: #CC2327;*/
}
</style>

<script type="text/babel">
export default {
    props: ['platform'],

    data() {
        return {
            icons: {
                analytics: 'fa fa-wordpress',
                instagram: 'fa fa-instagram',
                instagram_business: 'fa fa-instagram',
                youtube: 'fa fa-youtube-play',
                betterhype: 'icon-betterhype',
            },
        }
    },

    computed: {
        iconClass() {
            return this.$get(this.icons, this.platform.slug)
        },
    },
}
</script>
